import { render, staticRenderFns } from "./OverlayAsset.vue?vue&type=template&id=0d17da4c&scoped=true&"
import script from "./OverlayAsset.vue?vue&type=script&lang=js&"
export * from "./OverlayAsset.vue?vue&type=script&lang=js&"
import style0 from "./OverlayAsset.vue?vue&type=style&index=0&id=0d17da4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d17da4c",
  null
  
)

export default component.exports